import { createContext, useContext } from 'react'
import type { Me } from '../api/types'

export const SessionContext = createContext<Me | null>(null)

/** The signed-in user. Only valid below `<RequireSession>`. */
export function useSession(): Me {
  const me = useContext(SessionContext)
  if (!me) throw new Error('useSession must be used below <RequireSession>')
  return me
}
